import React, { useState, useRef } from 'react';
import BusinessStyles from './AddOurBusiness.module.css';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { setNotifications, setNotificationCount, fetchNotifications } from '../../state/GlobalState';

const AddOurBusiness = () => {
  const location = useLocation();
  const data = location.state;
  console.log(data);

  const navigate = useNavigate();
  
  // get data from redux
  const name = useSelector((state) => state.globalData.name);
  const count = useSelector((state) => state.globalData.notificationCount);
  const dispatch = useDispatch();

  const inputRef = useRef();
  const token=useSelector((state)=>state.globalData.token);
  const [file, setFile] = useState(null);
  const [businessData, setBusinessData] = useState({
    bannerName: '',
    bannerDescription: '',
    bannerBtnLink: '',
  });
  const [source, setSource] = useState();
  const [fileName, setFileName] = useState('');
  const [imageSelect, setImageSelect] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBusinessData({ ...businessData, [name]: value });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file.name);
    const url = URL.createObjectURL(file);
    setSource(url);
    setImageSelect(true);
    setFile(file);
  };

  const handleChoose = (event) => {
    inputRef.current.click();
  };

  const discardImage = (event) => {
    setSource(null);
    setFileName('');
    setFile(null);
    inputRef.current.value = '';
    setImageSelect(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formDataObj = new FormData();
    formDataObj.append('file', file);
    formDataObj.append('bannerName', businessData.bannerName);
    formDataObj.append('bannerDescription', businessData.bannerDescription);
    formDataObj.append('bannerBtnLink', businessData.bannerBtnLink);

    try {
      const imageResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/banner/uploadBannerImage`,
        formDataObj,
        {
          headers: {
            'Content-Type': 'image/jpeg',
            "Authorization": `Bearer ${token}`

          },
        }
      );
      console.log(imageResponse);

      const businessResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/banner/addBannerDetails/${imageResponse.data.imgId}`,
        businessData,
        {
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
          },
        }
      );
      // console.log(businessResponse);

      dispatch(fetchNotifications());

      alert('Banner Added.');
      navigate('/homebanner');

      dispatch(
        setNotificationCount({
          count: count + 1,
        })
      );

    //   alert('Business Added.');
      discardImage();
      navigate('/homebanner');
    } catch (error) {
      console.error(error);
      // Handle error here, display an error message or take appropriate action
      alert('Failed to add business. Please try again.');
    }
  };

  return (
    <div className={BusinessStyles.businessMain}>
      <div className={BusinessStyles.businessContent}>
        <form action="" className={BusinessStyles.businessForm} onSubmit={handleSubmit} encType="multipart/form-data">
          <label className={BusinessStyles.businessFormLabel}>Title</label>
          <input className={BusinessStyles.businessFormText} type="text" value={businessData.bannerName} name="bannerName" onChange={handleInputChange} />
          <label className={BusinessStyles.businessFormLabel}>Description</label>
          <textarea className={BusinessStyles.businessFormDesc} value={businessData.bannerDescription} name="bannerDescription" onChange={handleInputChange} />
          <label className={BusinessStyles.businessFormLabel}>Link</label>
          <input className={BusinessStyles.businessFormText} type="text" value={businessData.bannerBtnLink} name="bannerBtnLink" onChange={handleInputChange} />
          <label className={BusinessStyles.businessFormLabel}>Upload</label>
          <div className={BusinessStyles.ImgInput}>
            <input ref={inputRef} className={BusinessStyles.ImgInput_input} type="file" onChange={handleFileChange} />
            {!source && <button type="button" onClick={handleChoose}>Choose</button>}
            {source && (
              <img className={BusinessStyles.ImgInput_img} width="100%" src={source} alt="uploadedimage" />
            )}
          </div>
          <div className={BusinessStyles.ImgInput_footer}>
            {imageSelect && (
              <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                {fileName}
                <DeleteForeverOutlinedIcon onClick={discardImage} sx={{ cursor: 'pointer' }} />
              </div>
            )}
          </div>
          <Button variant="contained" type="submit" className={BusinessStyles.saveChanges}>
            Save changes
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AddOurBusiness;
